import { createSlice } from '@reduxjs/toolkit';
import { getBreachResponsibleAreaList } from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
	breachResponsibleAreaList: [],
	breachResponsibleAreaListSelect: [],
	isLoadingList: false,
	isSuccess: false,
};

const BreachResponsibleAreaSlice = createSlice({
	name: 'BreachResponsibleArea',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(getBreachResponsibleAreaList.pending, state => {
			state.isLoadingList = true;
			state.isSuccess = false;
		});

		builder.addCase(getBreachResponsibleAreaList.fulfilled, (state, action) => {
			const breachResponsibleAreaList = action.payload || [];
			state.breachResponsibleAreaList = breachResponsibleAreaList;
			state.breachResponsibleAreaListSelect = breachResponsibleAreaList.map(item => ({
				item,
				value: item._id,
				label: getOptionLabel(item),
			}));
			state.isLoadingList = false;
			state.isSuccess = true;
		});

		builder.addCase(getBreachResponsibleAreaList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isSuccess = false;
		});
	},
});

export default BreachResponsibleAreaSlice.reducer;
